import { TbCircleLetterC } from 'react-icons/tb';
import PropTypes from 'prop-types';

import { colorforCSA } from '../../../../../utils/dataStatus';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';

const CodButton = ({ dailyWorkReport, fetchData, handleChangedActions, selectedDate }) => {
  const { activeProgramPointApprovalModal } = useWorkReportModals();

  const mostrarPuntos = () => {
    if (dailyWorkReport?.variosValoresOperativos) {
      return (
        <TbCircleLetterC
          color={colorforCSA.withCSA}
          size={25}
          style={{ backgroundColor: 'transparent' }}
        />
      ); // Icono azul si hay varios puntos
    }
    if (dailyWorkReport.codigoOperativo) {
      return (
        <span style={{ marginLeft: '10px', marginRight: '10px' }}>
          {dailyWorkReport?.codigoOperativo}
        </span>
      ); // Mostrar el valor del punto si solo hay uno
    }

    return <TbCircleLetterC color={colorforCSA.withoutCSA} size={25} />; // Icono rojo si no hay puntos
  };

  const handleOnClick = () => {
    activeProgramPointApprovalModal({
      daily: dailyWorkReport,
      fetchData,
      handleChangedActions,
      line: {
        positionName: dailyWorkReport?.posicionSap,
        lineName: dailyWorkReport?.lineaSap,
        idParteDiario: dailyWorkReport?.idParteDiario,
        eventoSigla: dailyWorkReport?.eventoSigla,
        estadoEnum: dailyWorkReport?.estadoEnum,
        tienePuntosPrograma: dailyWorkReport?.notificaPorPuntosPrograma,
        puntoPrograma: dailyWorkReport?.puntoPrograma,
        unidadMedida: dailyWorkReport?.unidadMedida,
        notificaPorCSA: dailyWorkReport?.variosValoresOperativos || dailyWorkReport.codigoOperativo,
        cantidad: dailyWorkReport?.cantidad,
        isApproval: true
      },
      dateSelect: selectedDate,
      viewCSA: true,
      editCSA: true,
      defaultValue: true
    });
  };

  const viewTooltip = () => {
    if (dailyWorkReport?.variosValoresOperativos) {
      return 'Multiples Códigos de costo';
    }
    if (dailyWorkReport?.codigoOperativo) {
      return dailyWorkReport?.detalleOperativo;
    }

    return null;
  };

  return (
    <ComponentWithTooltip id="hidden-tooltip-cod" tooltipText={viewTooltip()}>
      <div>
        <button
          aria-label="CSA"
          // disabled={disabledButton}
          onClick={handleOnClick}
          style={{
            backgroundColor: 'transparent',
            border: 'none'
            // cursor: !disabledButton ? 'pointer' : 'default'
          }}
          type="button"
        >
          {mostrarPuntos()}
        </button>
      </div>
    </ComponentWithTooltip>
  );
};

export default CodButton;

CodButton.propTypes = {
  dailyWorkReport: PropTypes.shape({
    posicionSap: PropTypes.string,
    lineaSap: PropTypes.string,
    idParteDiario: PropTypes.number,
    estadoEnum: PropTypes.number,
    notificaPorPuntosPrograma: PropTypes.bool,
    puntoPrograma: PropTypes.number,
    unidadMedida: PropTypes.string,
    cantidad: PropTypes.string,
    variosValoresOperativos: PropTypes.bool,
    codigoOperativo: PropTypes.string,
    detalleOperativo: PropTypes.string,
    eventoSigla: PropTypes.string
  }).isRequired,
  fetchData: PropTypes.func,
  handleChangedActions: PropTypes.func,
  selectedDate: PropTypes.string
};

CodButton.defaultProps = {
  fetchData: () => {},
  handleChangedActions: () => {},
  selectedDate: ''
};
